import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const saveRating = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.SAVE_USER_RATING,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
